import {useState, useContext } from 'react'; 
import {CartContext} from '@/lib/cart_context.js'
export default function CartActions(show) {
  const {setShow, setPageUrl} = show;
  const [dropdownShow, setDropdownShow] = useState(false);
  const cart = useContext(CartContext);
  const requestQuote = () => {
    cart.requestQuote()
  }

  const showRequestAQuote = () => {
    //TODO: should recalculate when all part numbers are removed from cart
    return cart.items.some((item, i) => item.part_numbers?.length > 0 );

  }
  const createShare = async () => {
    let ans = confirm('Do you want to share this cart? This will create a copy of your current cart'); 
    if (ans) {
      let resp =  await cart.shareCart()
      if (resp.share_link) {
        setPageUrl(resp.share_link)
        setShow(true); 
      }
    }
  }
  const clearCart = () => {
    let ans = confirm('Are you sure you want to clear this cart?'); 
    if (ans) {
      cart.clearCart()
    }
  }


  return (
    <div className='lexcms-cart-actions'>
      <div className='lexcms-action-dropdown'>
        <button onClick={() => (setDropdownShow(!dropdownShow)) }
          className='lexcms-regular-button'>Actions</button>
        {dropdownShow &&
        <ul>
          <li><a onClick={( ) =>( createShare() ) }>Share</a> </li>
           { showRequestAQuote() &&
          <li><a onClick={( ) =>( requestQuote() ) }>Request a Quote</a> </li>
          }
        </ul>
        }
      </div>
      <div>
        <a onClick={() => (clearCart() ) }>Clear Cart</a>
      </div>
    </div>
  )
}

